import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import Restaurants from '../views/Restaurants.vue'
import Offers from '../views/Offers.vue'
import Cart from '../views/Cart.vue'
import Favorites from '../views/Favorites.vue'
import Checkout from '../views/Checkout.vue'
import RestaurantDetails from '../views/RestaurantDetails.vue'
import Login from '../views/Login.vue'
import Profile from '../views/Profile.vue'
import Orders from '../views/Orders.vue'
import Faq from '../views/Faq.vue'
import TermsOfUse from '../views/TermsOfUse.vue'
import ContactUs from '../views/ContactUs.vue'
import PrivacyPolicy from '../views/PrivacyPolicy.vue'
import Register from '../views/Register.vue'
import Location from '../views/Location.vue'
import AboutUs from '../views/AboutUs.vue'
import PromotionCheckout from '../views/PromotionCheckout.vue'
import Payment from '../views/Payment.vue'
import OrderSuccess from '../views/OrderSuccess.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'home',
    component: Home
  },  
  {
    path: '/location',
    name: 'location',
    component: Location
  },
  {
    path: '/signin',
    name: 'login',
    component: Login
  },
  {
    path: '/signup',
    name: 'register',
    component: Register
  },
  {
    path: '/restaurants/:id?',
    name: 'restaurants',
    component: Restaurants
  },
  {
    path: '/restaurant-details/:id/:branch_id',
    name: 'restaurant-details',
    component: RestaurantDetails
  },
  {
    path: '/offers',
    name: 'offers',
    component: Offers
  },
  {
    path: '/cart',
    name: 'cart',
    component: Cart
  },
  {
    path: '/favorites',
    name: 'favorites',
    component: Favorites
  },
  {
    path: '/checkout/:address_id',
    name: 'checkout',
    component: Checkout
  },
  {
    path: '/promotion-checkout',
    name: 'promotion-checkout',
    component: PromotionCheckout
  },
  {
    path: '/profile',
    name: 'profile',
    component: Profile
  },
  {
    path: '/orders',
    name: 'orders',
    component: Orders
  },
  {
    path: '/faq',
    name: 'faq',
    component: Faq
  },
  {
    path: '/terms-of-use',
    name: 'terms-of-use',
    component: TermsOfUse
  },
  {
    path: '/contact-us',
    name: 'contact-us',
    component: ContactUs
  },
  {
    path: '/privacy-policy',
    name: 'privacy-policy',
    component: PrivacyPolicy
  },
  {
    path: '/about-us',
    name: 'about-us',
    component: AboutUs
  },
  {
    path: '/payment',
    name: 'payment',
    component: Payment
  },
  {
    path: '/order-success',
    name: 'order-success',
    component: OrderSuccess
  },
 
  // {
  //   path: '/about',
  //   name: 'about',
  //   // route level code-splitting
  //   // this generates a separate chunk (about.[hash].js) for this route
  //   // which is lazy-loaded when the route is visited.
  //   component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  // }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
  scrollBehavior() {
    // always scroll to top
    return { x: 0, y: 0 };
  },
})

export default router
